import React from 'react';
import { Link } from '@blaze-cms/nextjs-components';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import { getAggregationCardUrl } from './helpers';
import { AGGS_CARD_SIZE_KEY } from './constants';

const AggregationCard = ({
  name,
  urlTemplate,
  productTypeUrl,
  overrideListingUrl,
  image,
  brandNames,
  disableClientRouting = true // temporary fix for the issue with the client routing
}) => {
  const { url, alt } = image || {};
  const urlToUse = getAggregationCardUrl(
    productTypeUrl,
    urlTemplate,
    overrideListingUrl,
    name,
    brandNames
  );
  const LinkComponent = disableClientRouting ? 'a' : Link;

  return (
    <LinkComponent
      href={urlToUse}
      className="card card--image-right__border-rounded popular-categories card--landscape">
      <div className="card__image card__image--image-right__border-rounded popular-categories card__image--landscape">
        {image && <ResponsiveImage src={url} alt={alt} sizeKey={AGGS_CARD_SIZE_KEY} />}
      </div>
      <div />
      <div className="card__content-wrapper card__content-wrapper--image-right__border-rounded popular-categories card__content-wrapper--landscape">
        <div className="card__content card__content--image-right__border-rounded popular-categories card__content--landscape">
          <div className="card__title card__title--image-right__border-rounded popular-categories card__title--landscape">
            {name}
          </div>
        </div>
      </div>
    </LinkComponent>
  );
};

export default AggregationCard;
